module.exports = __webpack_public_path__ + "img/addGroupImage.07a2df86.svg";